import Select from 'react-select'
import cns from 'classnames'
import { useLazyQuery } from '@apollo/client'
import { useContext, useMemo, useRef, useState } from 'react'
import { searchPayers as searchPayersQuery } from './queries.graphql'
import useDebounce from 'hooks/use-debounce'
import s from './styles.module.css'
import cmsSurveyContext from 'contexts/cms-survey-context'
import { useIsMobileLayout } from 'components/dashboard/clients/hooks'

const PayerSearch = ({
  onChange,
}: {
  onChange: (payer: { value: string; label: string; memberId: string }) => void
}) => {
  const { setNeedMemberId } = useContext(cmsSurveyContext)
  const [searchTerm, setSearchTerm] = useState('')
  const [isTyping, setIsTyping] = useState(false)
  const { selectedPayer, setSelectedPayer } = useContext(cmsSurveyContext)
  const isMobile = useIsMobileLayout()
  const [search, { loading: payersLoading, data: payerData }] =
    useLazyQuery(searchPayersQuery)

  const payerOptions = useMemo(
    () =>
      payerData?.searchBridgePayers?.map(payer => ({
        value: payer.id,
        label: payer.name,
        memberId: payer.memberId,
      })) || [],
    [payerData]
  )

  const debouncedSearch = useDebounce((value: string) => {
    if (value.length >= 2) {
      search({
        variables: { searchTerm: value || '' },
      })
    }
    setIsTyping(false)
  }, 300)

  const selectRef = useRef(null)

  return (
    <div className={s.selectContainer}>
      <Select
        ref={selectRef}
        value={selectedPayer}
        options={payerOptions}
        className={cns(s.select)}
        classNamePrefix="select"
        placeholder="Search..."
        isClearable
        filterOption={() => true}
        onFocus={() => {
          selectRef?.current?.controlRef?.scrollIntoView()
        }}
        styles={{
          menu: base => ({
            ...base,
            maxHeight: isMobile ? 220 : undefined,
          }),
          menuList: base => ({
            ...base,
            maxHeight: isMobile ? 220 : undefined,
          }),
        }}
        components={{
          DropdownIndicator: null,
        }}
        onInputChange={value => {
          setIsTyping(true)
          debouncedSearch(value)
          setSearchTerm(value)
        }}
        onChange={option => {
          setSelectedPayer(option)
          if (option) {
            onChange(option)
            setNeedMemberId(option.memberId === 'true' ? true : false)
          } else {
            onChange(null)
            setNeedMemberId(false)
          }
        }}
        noOptionsMessage={() => {
          if (searchTerm && searchTerm.length >= 2 && !isTyping) {
            return payersLoading
              ? 'Searching...'
              : 'No insurance companies found'
          }
          return null
        }}
      />
    </div>
  )
}

export default PayerSearch
